import _slicedToArray from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _typeof from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/typeof.js";
import _createForOfIteratorHelper from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.filter.js";
// Copyright 2017-2022 @polkadot/api authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { l } from "./logging.js";
export function filterEvents(txHash, _ref, allEvents, status) {
  var _ref$block = _ref.block,
      extrinsics = _ref$block.extrinsics,
      header = _ref$block.header;

  // extrinsics to hashes
  var _iterator = _createForOfIteratorHelper(extrinsics.entries()),
      _step;

  try {
    var _loop = function _loop() {
      var _step$value = _slicedToArray(_step.value, 2),
          txIndex = _step$value[0],
          x = _step$value[1];

      if (x.hash.eq(txHash)) {
        return {
          v: {
            events: allEvents.filter(function (_ref2) {
              var phase = _ref2.phase;
              return phase.isApplyExtrinsic && phase.asApplyExtrinsic.eqn(txIndex);
            }),
            txIndex: txIndex
          }
        };
      }
    };

    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _ret = _loop();

      if (_typeof(_ret) === "object") return _ret.v;
    } // if we do get the block after finalized, it _should_ be there
    // only warn on filtering with isInBlock (finalization finalizes after)

  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  if (status.isInBlock) {
    var allHashes = extrinsics.map(function (x) {
      return x.hash.toHex();
    });
    l.warn("block ".concat(header.hash.toHex(), ": Unable to find extrinsic ").concat(txHash.toHex(), " inside ").concat(allHashes.join(', ')));
  }

  return {};
}